import React, { useEffect, useState } from "react";
import cs from "classnames";
import { NavLink } from "react-router-dom";

import { WorkplaceFields } from "../../../api/graphql/workplaces";
import { useRouter } from "../../../lib/hooks/useRouter";
import { getWorkplaceChildren } from "../helpers/getWorkplaceChildren";
import { getWorkplaceIcon } from "../helpers/getWorkplaceInformation";
import { Icon } from "../../shared/Icon/Icon";

interface Props {
  item: WorkplaceFields;
  toggleParent: (value: boolean) => void;
  allToggled?: boolean;
  selectedDestinationId?: string;
  onSelectDestination: (item: WorkplaceFields) => void;
}

const hiddenWorkplaceTypes = new Set(["Room", "Desk", "Wayfinder"]);

export const MoveWorkspaceTreeLevel = ({
  item,
  toggleParent,
  allToggled,
  selectedDestinationId,
  onSelectDestination,
}: Props) => {
  const { pathname } = useRouter();
  const isActive = pathname.includes(item.id);
  const [toggle, setToggle] = useState(() => isActive);

  useEffect(() => {
    if (allToggled !== undefined) {
      setToggle(allToggled);
    }
  }, [allToggled]);

  const icon = getWorkplaceIcon(item.__typename);
  const workplaceChildren = getWorkplaceChildren(item);
  const hasChildren = workplaceChildren.some(
    (childGroup) => childGroup && childGroup.length > 0
  );

  const classes = cs("WorkplacesTreeLevel", {
    "WorkplacesTreeLevel--open": toggle,
    "WorkplacesTreeLevel--active": isActive,
    "WorkplacesTreeLevel--space": !hasChildren,
  });

  const subLevelClasses = cs("WorkplacesTreeLevel__sub-level", {
    "WorkplacesTreeLevel__sub-level--open": toggle,
  });

  const isSelected = selectedDestinationId === item.id;

  return (
    <>
      <div className={classes}>
        <div className="WorkplacesTreeLevel__wrapper">
          {hasChildren && (
            <span
              onClick={() => setToggle((prev) => !prev)}
              className="WorkplacesTreeLevel__toggle"
            ></span>
          )}
          <NavLink
            className="WorkplacesTreeLevel__link"
            onClick={(event) => {
              event.preventDefault();
              onSelectDestination(item);
            }}
            to="#"
          >
            <div className="WorkplacesTreeLevel__icon">
              <Icon icon={icon} />
            </div>
            <h3 className="WorkplacesTreeLevel__name">{item.name}</h3>
          </NavLink>
          <div
            className="WorkplacesTreeLevel__status"
            onClick={() => onSelectDestination(item)}
          >
            <Icon icon={isSelected ? "radio-checked-alt" : "radio-default"} />
          </div>
        </div>
      </div>
      {hasChildren && (
        <div className={subLevelClasses}>
          {workplaceChildren.map((child) => {
            return child
              ?.filter(
                (workplace) => !hiddenWorkplaceTypes.has(workplace.__typename)
              )
              .map((workplace) => (
                <MoveWorkspaceTreeLevel
                  item={workplace}
                  key={`${workplace.id}-move-tree-level`}
                  toggleParent={(value) => {
                    setToggle(value);
                    toggleParent(value);
                  }}
                  allToggled={allToggled}
                  selectedDestinationId={selectedDestinationId}
                  onSelectDestination={onSelectDestination}
                />
              ));
          })}
        </div>
      )}
    </>
  );
};
